import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'age'
})
export class AgePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) { }

  transform(value?: string | number | Date): string | undefined {
    if (value === undefined || value === '' || value as number < 0) {
      return undefined;
    }

    let age: number | undefined;
    let ageType: 'month' | 'year' = 'year';
    const date = value ? new Date(value) : undefined;
    if (date) {
      age = Math.round(((new Date().getTime()) - date.getTime()) / 31_536_000_000);
      if (age < 1) {
        age = Math.round(((new Date().getTime()) - date.getTime()) / 2_592_000_000);
        if (age < 1) {
          age = 1;
        }

        ageType = 'month';
      }
    }

    return `${age} ${this.translateService.instant(`age.${ageType}`)}`;
  }
}
